var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconComplaints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2H6C3.794 2 2 3.794 2 6V13.034C2 15.24 3.794 17.034 6 17.034H7.021V20.938C7.021 21.335 7.256 21.695 7.622 21.855C7.622 21.855 8.199 22.138 8.702 21.671L13.698 17.034H18.001C20.207 17.034 22.001 15.24 22.001 13.034V6C22 3.794 20.206 2 18 2ZM13 12.63C13 13.182 12.553 13.63 12 13.63C11.447 13.63 11 13.182 11 12.63V12.514C11 11.962 11.447 11.514 12 11.514C12.553 11.514 13 11.962 13 12.514V12.63ZM13 9.781C13 10.333 12.553 10.781 12 10.781C11.447 10.781 11 10.333 11 9.781V6.094C11 5.542 11.447 5.094 12 5.094C12.553 5.094 13 5.542 13 6.094V9.781Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComplaints);
export default __webpack_public_path__ + "static/media/icon_complaints.1ee6b66273ebfd37766c5816e4343ef3.svg";
export { ForwardRef as ReactComponent };